/**
 * On-screen text, mainly in Twi with some Ga. Short English hints follow the control labels so
 * new players still know what each key does. Native speakers: please correct anything that reads wrong.
 */
export const UI_TEXT = {
  title: 'Trotro Run',
  /** Shown under the title. */
  subtitle: 'Accra',
  /** "Let's go!" */
  start: 'Yɛnkɔ!',
  /** "Stop! Take the passengers" */
  brakeToLoad: 'GYINA! FA NKURƆFOƆ!',
  /** "Go to the right" */
  keepRight: 'Kɔ nifa so → kerb lane',
  /** "We're reaching…" */
  nowEntering: 'Yɛreduru',
  controls: [
    ['← →', 'dane benkum / nifa · change lane'],
    ['↑', 'pia · gas'],
    ['↓', 'gyina · brake'],
    ['Space', 'huri · hop'],
    ['H', 'bɔ abɛn · hoot'],
    ['R', 'radio'],
    ['T', 'radio · play / pause'],
    ['P', 'gyina kakra · pause'],
    ['M', 'yɛ dinn · mute'],
  ],
  howTo: [
    'Gyina yellow box no mu na fa nkurɔfoɔ',
    'Ma wɔn nsi wɔn gyinabea: oyiwaladonn, sika ba!',
    'Space: huri; kanea kɔkɔɔ a, gyina',
  ],
} as const;
